import { render } from "./FacturasProveedor.vue?vue&type=template&id=606ee407&scoped=true"
import script from "./FacturasProveedor.vue?vue&type=script&lang=js"
export * from "./FacturasProveedor.vue?vue&type=script&lang=js"

import "./FacturasProveedor.vue?vue&type=style&index=0&id=606ee407&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-606ee407"]])

export default __exports__